"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/objectWithoutProperties"));

var _react = _interopRequireWildcard(require("react"));

var _material = require("@mui/material");

var _AddCircleOutline = _interopRequireDefault(require("@mui/icons-material/AddCircleOutline"));

var _styledComponents = require("./styledComponents");

var _excluded = ["fileSelectedHandler", "fileName", "label", "placeholder", "popover", "filter", "helperText", "disabled", "error"];

var FileInput = function FileInput(_ref) {
  var fileSelectedHandler = _ref.fileSelectedHandler,
      fileName = _ref.fileName,
      label = _ref.label,
      placeholder = _ref.placeholder,
      popover = _ref.popover,
      filter = _ref.filter,
      helperText = _ref.helperText,
      disabled = _ref.disabled,
      error = _ref.error,
      rest = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  var fileInputRef = (0, _react.useRef)();
  var hasError = error && error.constructor === Object && Object.keys(error).length !== 0;

  var clickHandler = function clickHandler(evt) {
    evt.stopPropagation();
    evt.preventDefault();
    fileInputRef.current.click();
  };

  var InputIcon = function InputIcon() {
    return /*#__PURE__*/_react.default.createElement(_material.InputAdornment, {
      position: "end"
    }, /*#__PURE__*/_react.default.createElement(_material.IconButton, {
      size: "large"
    }, /*#__PURE__*/_react.default.createElement(_AddCircleOutline.default, {
      fontSize: "large",
      color: hasError ? 'error' : ''
    })));
  };

  return /*#__PURE__*/_react.default.createElement(_material.Box, {
    style: disabled ? {
      cursor: 'not-allowed'
    } : {}
  }, /*#__PURE__*/_react.default.createElement("input", {
    type: "file",
    accept: filter,
    style: {
      display: 'none'
    },
    onChange: fileSelectedHandler,
    ref: fileInputRef
  }), /*#__PURE__*/_react.default.createElement(_styledComponents.StyledInput, Object.assign({
    label: label,
    onClick: clickHandler,
    InputProps: {
      endAdornment: /*#__PURE__*/_react.default.createElement(InputIcon, null)
    },
    value: fileName || '',
    placeholder: placeholder,
    popover: popover,
    helperText: helperText,
    disabled: disabled,
    style: disabled ? {
      pointerEvents: 'none'
    } : {},
    error: error
  }, rest)));
};

FileInput.defaultProps = {
  fileName: '',
  filter: 'image/*',
  placeholder: '',
  popover: '',
  helperText: '',
  disabled: false,
  error: {}
};
var _default = FileInput;
exports.default = _default;